import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CampaignWizardComponent } from './campaign-wizard.component';
import { StepOneComponent } from './step-one/step-one.component';
import { StepTwoComponent } from './step-two/step-two.component';
import { StepThreeComponent } from './step-three/step-three.component';
import { StepFourComponent } from './step-four/step-four.component';
import { GlobalModulesModule } from '../../global-modules/global-modules.module';
import { CopierComponent } from './copier/copier.component';
import { MatSelectModule } from '@angular/material/select';
import { CampaignSelectorComponent } from './campaign-selector/campaign-selector.component';
import { DistributionSelectorComponent } from './distribution-selector/distribution-selector.component';
import { CouponGeneratorComponent } from './coupon-generator/coupon-generator.component';


@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
    MatSelectModule
  ],
  declarations: [
    CampaignWizardComponent, 
    StepOneComponent, 
    StepTwoComponent, 
    StepThreeComponent, 
    StepFourComponent, 
    CopierComponent, 
    CampaignSelectorComponent, 
    DistributionSelectorComponent, 
    CouponGeneratorComponent
  ],
  exports: [
    CampaignWizardComponent, 
    CampaignSelectorComponent, 
    DistributionSelectorComponent
  ],
  entryComponents: [
    CampaignWizardComponent, 
    CouponGeneratorComponent
  ]
})
export class CampaignWizardModule { }
